import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface VerticalSwitcherItemProps {
  icon: ReactNode;
  label: ReactNode;
  isActive: boolean;
  onClick: () => void;
}

interface StylledContainerDivProps {
  $isActive: boolean;
}

/*
 * Style.
 */

const StyledContainerDiv = styled.div<StylledContainerDivProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 48px;
  height: 51px;
  border-radius: 8px;
  background: ${(p) =>
    p.$isActive ? p.theme.verticalSwitcher.itemBackgroundActive : p.theme.verticalSwitcher.itemBackground};

  &:hover {
    background: ${(p) =>
      p.$isActive
        ? p.theme.verticalSwitcher.itemBackgroundActive
        : p.theme.verticalSwitcher.itemBackgroundHover};
  }
`;

const StyledIconContainerDiv = styled.div`
  color: ${(p) => p.theme.verticalSwitcher.itemIconColor};
`;

const StyledLabelContainerDiv = styled.div`
  color: ${(p) => p.theme.verticalSwitcher.itemColor};
  max-width: 44px;
  font-size: ${fontSizes.hardToRead};
  line-height: 11px;
  ${ellipsis()};
`;

/*
 * Component.
 */

export const VerticalSwitcherItem: FC<VerticalSwitcherItemProps> = (props) => {
  const {icon, label, isActive, onClick} = props;
  return (
    <TooltipCoordinator render={() => label} placement="bottom">
      <StyledContainerDiv $isActive={isActive} onClick={onClick}>
        <StyledIconContainerDiv>{icon}</StyledIconContainerDiv>
        <StyledLabelContainerDiv>
          <TooltipOverflowCondition>{label}</TooltipOverflowCondition>
        </StyledLabelContainerDiv>
      </StyledContainerDiv>
    </TooltipCoordinator>
  );
};
